import { AbstractControl, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordMatchValidator(passwordControl: () => AbstractControl): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    // Do not check if the formGroup has not been initialized yet
    if (!control.parent) {
      return null;
    }

    const otherControl = passwordControl();

    if (control.value !== otherControl.value) {
      return { passwordMatch: true };
    }

    return null;
  };
}
